import { ServerConfig } from "@/config/config";
import { BrowseSettings } from "@/models/browse-settings";
import { Axios } from "@/services/auth-service";
import Vue from "vue";

export const BrowseService = new Vue({
	computed: {
		url():string {
			return `${ServerConfig.host}/admin/browse-settings`;
		}
	},
	methods: {
		async getBrowseSettings():Promise<BrowseSettings[]> {
			let result = await Axios.get(`${this.url}`);
			return result.data.map((d:any) => new BrowseSettings(d));
		}
	}
});